// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tpig","textarea":"styles_textarea__1Ghcg"};